import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PropertyService } from 'app/internal/property/shared/services/property.service';

/**
 * Resolver that checks for sp_ref=email and propertyId query params
 * and updates the selected property accordingly.
 */
@Injectable({ providedIn: 'root' })
export class UrlQueryParamResolver implements Resolve<boolean> {
  constructor(private propertyService: PropertyService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const spRef = route.queryParamMap.get('sp_ref');
    const propertyId = route.queryParamMap.get('propertyId');
    
    if (spRef === 'email' && propertyId) {
      this.propertyService.setSelectedPropertyId(propertyId);

    }

    return of(true);
  }
}